module.exports = __webpack_public_path__ + "static/media/postTopTitle.ace192af.svg";